// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"210":"b4b92ea9","254":"e5da7544","325":"9b963111","592":"56dea2dc","959":"895dcf01"}[chunkId] + ".chunk.js";
};